import { render, staticRenderFns } from "./window-item-quarternary.vue?vue&type=template&id=76dcaa17&scoped=true&"
import script from "./window-item-quarternary.vue?vue&type=script&lang=js&"
export * from "./window-item-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dcaa17",
  null
  
)

export default component.exports